export default "__VITE_ASSET__BvPh6JHC__"